import { createFileRoute } from "@tanstack/react-router";

import PeopleUserPage from "@/pages/PeopleUserPage";

export const Route = createFileRoute("/_app/(people)/people/$currentTab/$clientId")({
  component: () => <PeopleUserPage />,
});
